import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { BehaviorSubject, map } from 'rxjs';

import { CreationStep } from '../../models/step.model';

@Component({
  selector: 'tsq-steps-status',
  templateUrl: './steps-status.component.html',
  styles: [
    `
      .stepper-drop-shadow {
        filter: drop-shadow(0px 0px 16px #1c2e5229);
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepsStatusComponent {
  @Input() creationSteps: CreationStep[];
  @Input() activeStep: number;

  private readonly schemaSubject = new BehaviorSubject<'primary' | 'new-primary'>('primary');

  protected readonly svgActiveClasses$ = this.schemaSubject.asObservable().pipe(
    map(val => {
      const isNewPrimarySchema = val === 'new-primary';

      return {
        background: isNewPrimarySchema ? 'text-new-primary-n3' : 'text-primary-n1',
        foreground: isNewPrimarySchema ? 'text-new-primary-p2' : 'text-primary-p1',
      };
    }),
  );

  @Input() set schema(value: 'new-primary' | 'primary') {
    this.schemaSubject.next(value);
  }

  gridClass(): string {
    return `grid grid-cols-${this.creationSteps.length}`;
  }
}
